/**
 * WebGLのカメラを作るファイル
 */

import { PerspectiveCamera, Vector3 } from "three";

import store from "@/store";
import configRoom from "@/config/room";

const initMode = configRoom.cameraInitMode;
const firstPersonPosition = new Vector3(0, 0, 1e-5);
const thirdPersonPosition = new Vector3(0, 0, 0);

export default class Camera extends PerspectiveCamera {
  constructor() {
    super();

    this.time = 0;
    this.isActive = false;
    this.mode = initMode;
  }
  setFloorSize(size) {
    this.floorSize = size;
  }
  start() {
    this.far = 1000;
    this.isActive = true;
    this.mode = initMode;

    // 間取り図が全て見えるカメラのY座標を設定
    this.setFocalLength(50);
    const { meterPerPixel } = store.state.webgl;
    const floorWidth = this.floorSize.x * meterPerPixel;
    const floorHeight = this.floorSize.y * meterPerPixel;
    const fovInRadians = (this.fov * Math.PI) / 180;

    const { isMobile } = store.state;
    let posYForW, posYForH;
    if (isMobile) {
      posYForW = floorWidth / this.aspect / 2 / Math.tan(fovInRadians / 2);
      posYForH = (floorHeight + 4) / 2 / Math.tan(fovInRadians / 2);
    } else {
      posYForW =
        ((floorWidth / this.aspect) * 1.7 * 1.5) /
        2 /
        Math.tan(fovInRadians / 2);
      posYForH = (floorHeight * 1.3 * 1.5) / 2 / Math.tan(fovInRadians / 2);
    }
    thirdPersonPosition.setY(Math.max(posYForW, posYForH));

    // Initialize
    this.changeMode(configRoom.cameraInitMode);
  }
  update(time) {
    if (this.isActive === false) return;
    this.time += time;
  }
  resize() {
    const { resolution } = store.state;

    this.aspect = resolution.x / resolution.y;
    this.updateProjectionMatrix();
  }

  /**
   * カメラモードの切り替えに合わせてカメラの設定を変える
   *
   * @param {string} mode
   */
  changeMode(mode) {
    if (mode === "firstPerson") {
      this.setFocalLength(12);
      this.position.set(
        firstPersonPosition.x,
        firstPersonPosition.y,
        firstPersonPosition.z
      );
    } else if (mode === "thirdPerson") {
      this.setFocalLength(50);
      this.position.set(
        thirdPersonPosition.x,
        thirdPersonPosition.y,
        thirdPersonPosition.z
      );
      this.lookAt(0, 0, 0);
    }
  }
}
